module.exports = __webpack_public_path__ + "img/ltkitbag-3x.3e6d524.jpg";